import service from '../../config/axios.config';

export const getObjectiveKPIEntriesByObjectiveKPI = ({
  objectiveId,
  kpiId
}) =>
  service.get(
    `/objectives/${objectiveId}/kpis/${kpiId}/kpientries`
  );

export const createObjectiveKPIEntry = ({
  kpiEntry,
  objectiveId,
  kpiId
}) =>
  service.post(
    `/objectives/${objectiveId}/kpis/${kpiId}/kpientries`,
    {
      kpiEntry
    }
  );

export const updateObjectiveKPIEntry = ({
  kpiEntry,
  objectiveId,
  kpiId
}) =>
  service.put(
    `/objectives/${objectiveId}/kpis/${kpiId}/kpientries`,
    {
      kpiEntry
    }
  );

export const deleteObjectiveKPIEntry = ({
  entryId,
  kpiId,
  objectiveId
}) =>
  service.delete(
    `/objectives/${objectiveId}/kpis/${kpiId}/kpientries/${entryId}`
  );
